import { useState } from "react";
import reviewTrainingService from "./useReviewTrainingService";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import useAuth from "../../../core/hooks/useAuth";

const useReviewTraining = () => {
  const [page, setPage] = useState(1);
  const { trainingId, userId } = useParams();
  const { authenticatedUser } = useAuth();

  const { 
    data: evaluationScores, 
    error: evaluationScoresError, 
    isFetching: evaluationScoresIsFetching 
  } = useQuery(
    "trainingEvaluationsScores",
    () => reviewTrainingService.getEvaluationScoresByTrainingIdAndUserId(trainingId,userId)
  );

  const { data, error, isFetching } = useQuery(
    "trainingEvaluationsQuestions",
    () => reviewTrainingService.getTrainingEvaluationsQuestionsData(page, 11)
  );

  const {
    data: trainingHeader,
    error: trainingError,
    isFetching: isFetchingTraining
  } = useQuery(['trainingInformation', trainingId], () =>
    reviewTrainingService.getTrainingInformationHeader(trainingId),
    {
      initialData: {
        data: { data: [] }
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  return {
    trainingId, 
    userId,
    data: data?.data?.data,
    isFetching,
    error,
    page,
    setPage,
    trainingHeader,
    trainingError,
    isFetchingTraining,
    authenticatedUser,
    evaluationScores: evaluationScores?.data,
    evaluationScoresError,
    evaluationScoresIsFetching,
  };
};

export default useReviewTraining;
